/**
 * Created by Carsten Hibbeler
 * User: CBuehler on 12.03.2018
 * Copyright: xdot GmbH 2018
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

const MultilineText = ({ children, onClick }) =>
    <div onClick={onClick ? onClick : undefined}>{children && children.split('\n').map((item, i) => <p key={i}>{item}</p>)}</div>;

MultilineText.propTypes = {
    children: PropTypes.string,
    onClick: PropTypes.func
};

export default MultilineText;



// WEBPACK FOOTER //
// ./js/components/MultilineText.jsx